import {Component, OnInit} from '@angular/core';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss']
})
export class CarouselComponent implements OnInit {
  items = [
    {
      icon: "crime",
      title: "Kuzuia Uhalifu",
      phoneNumber: "111"
    },
    {
      icon: "police",
      title: "Polisi",
      phoneNumber: "112"
    },
    {
      icon: "bribery",
      title: "Rushwa",
      phoneNumber: "113"
    },
    {
      icon: "fireandrescue",
      title: "Zimamoto na Uokoaji",
      phoneNumber: "114"
    },
    {
      icon: "ambulance",
      title: "Gari la wagonjwa m-Mama",
      phoneNumber: "115"
    },
    {
      icon: "genderDesk",
      title: "Dawati la Jinsia na Watoto",
      phoneNumber: "116"
    },
    {
      icon: "healthCall",
      title: "Afya",
      phoneNumber: "199"
    }
  ]

  currentIndex = 0;
  itemsToShow = 5;

  constructor(private breakpointObserver: BreakpointObserver) {}

  get visibleItems(): any[] {
    const start = this.currentIndex;
    const end = (start + this.itemsToShow) % this.items.length;
    if (start <= end) {
      return this.items.slice(start, end);
    } else {
      return [...this.items.slice(start), ...this.items.slice(0, end)];
    }
  }

  ngOnInit(): void {
    this.breakpointObserver.observe([Breakpoints.Handset]).subscribe(result => {
      if (result.matches) {
        this.itemsToShow = 1; // On mobile, show 1 item at a time
      } else {
        this.itemsToShow = 5; // On larger screens, show 5 items at a time
      }
    });
  }

  next(): void {
    this.currentIndex = (this.currentIndex + 1) % this.items.length;
  }

  prev(): void {
    this.currentIndex = (this.currentIndex - 1 + this.items.length) % this.items.length;
  }
}
